export default {
  error_messages: {
    orders_disabled: 'Zamówienia chwilowo niedostępne',
  },
};
